var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "destination-cards",
    class: _vm.orientation
  }, [_c('destination-option-card', {
    attrs: {
      "icon": "mdi-passport",
      "orientation": _vm.orientation,
      "title": _vm.$t('digital_product_passport'),
      "description": _vm.$t('destination_dpp_desc'),
      "selected": _vm.value === 'dpp'
    },
    on: {
      "select": function ($event) {
        return _vm.$emit('input', 'dpp');
      }
    },
    scopedSlots: _vm._u([_vm.$slots['dpp-action'] ? {
      key: "action",
      fn: function () {
        return [_vm._t("dpp-action")];
      },
      proxy: true
    } : null], null, true)
  }), _c('destination-option-card', {
    attrs: {
      "icon": "mdi-cellphone",
      "orientation": _vm.orientation,
      "title": _vm.$t('custom_landing_page'),
      "description": _vm.$t('destination_custom_desc'),
      "selected": _vm.value === 'custom'
    },
    on: {
      "select": function ($event) {
        return _vm.$emit('input', 'custom');
      }
    },
    scopedSlots: _vm._u([_vm.$slots['custom-action'] ? {
      key: "action",
      fn: function () {
        return [_vm._t("custom-action")];
      },
      proxy: true
    } : null], null, true)
  }), _c('destination-option-card', {
    attrs: {
      "icon": "mdi-history",
      "orientation": _vm.orientation,
      "title": _vm.$t('use_existing_landing_page'),
      "description": _vm.$t('destination_existing_desc'),
      "selected": _vm.value === 'existing'
    },
    on: {
      "select": function ($event) {
        return _vm.$emit('input', 'existing');
      }
    }
  }), _c('destination-option-card', {
    attrs: {
      "icon": "mdi-link",
      "orientation": _vm.orientation,
      "title": _vm.$t('redirect_to_custom_url'),
      "description": _vm.$t('destination_redirect_desc'),
      "selected": _vm.value === 'redirect'
    },
    on: {
      "select": function ($event) {
        return _vm.$emit('input', 'redirect');
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }